<template>
  <nav class="simple-navigation">
    <router-link
      v-for="page in navigationPages"
      :key="page?.id"
      :to="pathName(page?.url)"
      v-html="page?.title"
      class="nav-button"
      active-class="active"
      exact-active-class="active"
    />
  </nav>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import { yamlToArray, pageFromPath, pathName } from '@/utils'
import { computed } from 'vue'

const props = defineProps({
  pagelist: {
    type: String,
    default: ''
  }
})

const kql = useStore()

const navigationPages = computed(() => {
  if (!props.pagelist || !kql.pages) return []
  return yamlToArray(props.pagelist).map(uid => pageFromPath(uid, kql.pages)).filter(page => page)
})
</script>

<style scoped>
.simple-navigation {
  display: flex;
  align-items: center;
  gap: 2rem;
}

/* Exact styling copied from MenuNavigation */
:deep(.nav-button) {
  position: relative;
  font-size: var(--normal);
  cursor: pointer;
  background-color: transparent;
  outline: none;
  margin: 0;
  border: none;
  font-weight: 400;
  text-transform: uppercase;
}

:deep(.nav-button:active) {
  color: gray;
}
</style>
